import { Action, createReducer, on } from '@ngrx/store';
import * as AllActions from '../actions';
import { Device } from '../../internal-user/fleet-management/models/device.model';

export interface State {
  iotDeviceDetails: any;
}

export const initialState: State = {
  iotDeviceDetails: null,
};

const preProvisionReducer = createReducer(
  initialState,

  // GeTasks
  on(AllActions.FleetManagerActions.getIOTDeviceDetailsSuccessful , (state, action) => ({
      ...state,
      iotDeviceDetails: action.data
    })
  ),
  // The request succeeded; update only the matching device in the provisioned inventory.
  on(AllActions.FleetManagerActions.deviceDisabled, (state, { deviceId }) => {
    const deviceDetails = state.iotDeviceDetails;

    // Support a direct device array and the inventory API response.
    if (Array.isArray(deviceDetails)) {
      const updatedDevices = markDeviceDisabled(deviceDetails, deviceId);
      return updatedDevices === deviceDetails
        ? state
        : { ...state, iotDeviceDetails: updatedDevices };
    }

    // Keep the unprovisioned list and other response fields as they are.
    if (!deviceDetails || !Array.isArray(deviceDetails.provisioned)) {
      return state;
    }

    const provisioned = markDeviceDisabled(deviceDetails.provisioned, deviceId);
    return provisioned === deviceDetails.provisioned
      ? state
      : { ...state, iotDeviceDetails: { ...deviceDetails, provisioned } };
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return preProvisionReducer(state, action);
}

// Find the exact device ID, including devices nested under a root.
function markDeviceDisabled(devices: Device[], deviceId: string): Device[] {
  let changed = false;
  const updatedDevices = devices.map(device => {
    if (device.edgeDeviceId === deviceId) {
      changed = true;
      return {
        ...device,
        // The inventory response does not include the persisted Enabled flag.
        connectionState: 'Disabled'
      };
    }

    // Copy ancestors only when a nested device changed.
    const children = device.children
      ? markDeviceDisabled(device.children, deviceId)
      : device.children;
    if (children === device.children) {
      return device;
    }

    changed = true;
    return { ...device, children };
  });

  return changed ? updatedDevices : devices;
}
